// @flow
import { connect } from 'react-redux'
import React from 'react'
import Template from './Template'
import { setLoad, setUnload } from 'lib/notification/actions'
import { httpGet, wsUrl } from 'lib/http'
import { JOURNAL_IDS } from 'lib/constants'
import { Socket } from 'phoenix'
import { createStructuredSelector } from 'reselect'
import { email } from 'lib/user/selectors'

type Props = {
  email: String,
  onSubmit: Function,
  dispatch: Function,
}

type State = {
  journalId: string,
  quarter: string,
  year: string,
  statements: null,
}

class AccountStatements extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { journalId: '', quarter: '', year: '' }
  }

  connectToChannel = () => {
    const { dispatch, email } = this.props

    let socket = new Socket(wsUrl(), {
      params: {},
    })

    socket.connect()

    let channel = socket.channel(`async_task:${email}`)

    // Listen for the report
    channel.on('task_complete', ({ accountStatements }) => {
      this.setState({ statements: accountStatements })
      dispatch(setUnload())
    })

    channel.on('task_error', (error) => {
      dispatch(setBanner(`Error generating report: ${error}`, 'danger'))
      dispatch(setUnload())
    })

    channel.join().receive('error', (resp) => {
      dispatch(setBanner('Unable to join Conductor channel', 'danger'))
    })
  }

  componentDidMount() {
    this.connectToChannel()
  }

  canSubmit = () => {
    const { journalId, quarter, year } = this.state
    return journalId !== '' && quarter !== '' && year !== ''
  }

  handleInputChange = (event: SyntheticEvent<HTMLSelectElement>) => {
    const { name, value } = event.currentTarget ? event.currentTarget : { name: event.name, value: event.value ? event.value.value : '' }
    this.setState({ [name]: value })
  }

  fetchReport = () => {
    const { dispatch } = this.props
    const { journalId, quarter, year } = this.state
    dispatch(setLoad())
    const chunk_every = 100
    const query_string = `?chunk_every=${chunk_every}&journal_id=${journalId}&` + `quarter=${quarter}&` + `year=${year}`
    const trust_filter = (journal) => journal.value === journalId
    const trust = JOURNAL_IDS.find(trust_filter) || { label: journalId }
    this.setState({ statements: null })
    httpGet(`/admin/dcf-report${query_string}`)
  }

  render() {
    return (
      <Template
        canSubmit={this.canSubmit()}
        onChange={this.handleInputChange}
        onSubmit={this.fetchReport}
        quarter={this.state.quarter}
        year={this.state.year}
        journalId={this.state.journalId}
        statements={this.state.statements}
      />
    )
  }
}

export default connect(
  createStructuredSelector({
    email,
  }),
)(AccountStatements)
